// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-btn {\n  color: #666666;\n}\n\n.icon-btn:hover {\n  color: #00aaca;\n}\n\n.st0 {\n  fill: #666666;\n}\n\n.st0:hover {\n  fill: #00aaca;\n}\n\n.st1 {\n  fill: #ffffff;\n}\n\n.icon-disabled {\n  color: #dddddd;\n}\n\n.st-disabled {\n  fill: #dddddd;\n}\n", ""]);
// Exports
module.exports = exports;
